/** 
 * Author: Venkateswaran
 * Created Date: 16/11/2021
 * 
 * Import the necessary node-modules. If any of the nodes modules are not avaialble then 
 * install the node modules using the npm install command.
 * 
*/
import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as MenuAction from './MenuAction';
import * as $ from 'jquery';
const getASNData = async (PO_ID) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ASNApproval,
            SDIConstants.methodNames.GetASNData,
            JSON.stringify(PO_ID),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.GetASNData, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

       

    } catch (ex) {
        console.log(ex)
    }
};
const printPurchaseOrder = (PurchaseOrderBO) => {
    try {
        //;
        SDISVC.receiveFileBase64(
            SDIConstants.moduleNames.ASNApproval,
            SDIConstants.methodNames.PrintPurchaseOrder,
            JSON.stringify(PurchaseOrderBO),
            (data) => {
                if (data.success) {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        //;
                        let contentData = { type: SDIConstants.methodNames.PrintPurchaseOrder, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const addAttachment = async (files) => {
   
    try {
       
        SDISVC.uploadFile(
            SDIConstants.moduleNames.ASNApproval,
            SDIConstants.methodNames.ASN_Attachment,
            "",
            files,
            (data) => {

                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.ASN_Attachment, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

/**
 * Ref: 
 * 
 * downloadAttachment method gets called from the on clicking the title of the file
 * @param downloadBO
 */
const downloadAttachment = async (downloadBO) => {
    try {
        SDISVC.downloadFile(
            SDIConstants.moduleNames.ASNApproval,
            SDIConstants.methodNames.ASN_DownloadAttachment,
            JSON.stringify(downloadBO),
            downloadBO.fileName,
            (data) => {
                if (data.success) {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
/**
 * Ref: 
 * 
 * removeAttachment method gets called from when clicking the remove icon of the attachment
 * @param removeBO
 */
const removeAttachment = async (removeBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ASNApproval,
            SDIConstants.methodNames.ASN_RemoveAttachment,
            JSON.stringify(removeBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.ASN_RemoveAttachment, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const InsertASNData = async (ASNDataBO) => {
    try {

        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ASNApproval,
            SDIConstants.methodNames.InsertASNData,
            JSON.stringify(ASNDataBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.GetASNData, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const insertFavPage = async (insertFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_InsertFavPage,
            JSON.stringify(insertFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_InsertFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const deleteFavPage = async (deleteFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_DeleteFavPage,
            JSON.stringify(deleteFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_DeleteFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const getCurrentFavPage = async (getFavPageBO) => {
    try {
        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCurrentFavPage,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_CurrentFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
export {
    getASNData, printPurchaseOrder, addAttachment, downloadAttachment, removeAttachment, InsertASNData, deleteFavPage, insertFavPage, getCurrentFavPage
}